import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { NotificationService } from '@nrwl/common-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ControllerApiService } from '@nrwl/test-setup';
import { DataSourceService } from 'libs/datasource-management/src/lib/service/datatsource.service';

@Component({
  selector: 'nrwl-reports-setting',
  templateUrl: './reports-setting.component.html',
  styleUrls: ['./reports-setting.component.scss']
})
export class ReportsSettingComponent implements OnInit, OnDestroy {
  comment = '';
  fileName = '';
  showClearButton = false;
  isLoading = false;
  savedFile: File;
  serverConfig = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  svgImage: any;
  svgImagePreview: any;
  isUpload = false;
  isMessageUpload = false;
  disableSaveButton = true;
  // eslint-disable-next-line @typescript-eslint/member-ordering
  @ViewChild('file', { static: false }) file: ElementRef<HTMLInputElement>;
  // eslint-disable-next-line @typescript-eslint/member-ordering
  @ViewChild('divImage', { static: false }) divImage: ElementRef<HTMLImageElement>;
  public files: Set<File> = new Set();
  logoUrl: any;
  message: any;
  showmessage: any;
  private readonly unsubscribe: Subject<void> = new Subject();

  constructor(
    private notificationService: NotificationService,
    private controllerApiService: ControllerApiService,
    private readonly dataSourceService: DataSourceService
  ) {}
  ngOnInit() {
    this.init();
  }

  init(): any {
    this.getFusionReportsSettings();
  }

  getFusionReportsSettings(): any {
    this.isLoading = true;
    this.controllerApiService
      .getServerConfig()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          this.isLoading = false;
          this.serverConfig = response.data;
          const reportSettings = response.data.reports;
          if (reportSettings && reportSettings.logo && reportSettings.logo.url) {
            this.svgImage = '/' + reportSettings.logo.url; //'https://fusion-ctl-10.ral.ds.jdsu.net/images/viavi.png';
          } else {
            this.svgImage = '/images/viavi.png';
          }
          if (reportSettings && reportSettings.message) {
            this.comment = reportSettings.message;
            this.showmessage = reportSettings.message;
          } else {
            this.comment = '';
          }
        },
        () => {
          this.isLoading = false;
        }
      );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  onFilesAdded(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file: File = event.target.files[0];

      const reader = new FileReader();

      reader.onload = (loadEvent: any) => {
        this.svgImagePreview = loadEvent.target.result;
      };

      reader.readAsDataURL(file);

      this.disableSaveButton = false;
      this.showClearButton = true;
      this.savedFile = file;
      this.fileName = file.name;
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  click(event: any): void {
    event.preventDefault();
  }

  editMessage(): void {
    this.disableSaveButton = false;
  }

  removeLogo(): void {
    this.fileName = '';
    this.showClearButton = false;
    this.disableSaveButton = true;
    this.files.clear();
    if (this.file && this.file.nativeElement) {
      this.file.nativeElement.value = '';
    }
  }

  saveReportSettings(): void {
    if (this.savedFile) {
      const fileArr = [];
      fileArr.push(this.savedFile);
      this.uploadFile(fileArr, 'logo', 'logo');
    }
    const reports = {
      reports: {
        message: this.comment
      }
    };
    this.serverConfig['reports'].message = this.comment;
    this.dataSourceService
      .saveServerConfig(reports)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          if (response.status === 'success') {
            this.isLoading = false;
            this.isMessageUpload = true;
            this.removeLogo();
          } else {
            this.isLoading = false;
            this.isMessageUpload = false;
            this.notificationService.onFail('Message was not saved' + response.data.message);
          }
        },
        error => {
          this.isLoading = false;
          this.notificationService.onFail('Message was not saved. Please try again.');
        }
      );
    setTimeout(() => {
      this.getFusionReportsSettings();
      if (this.isUpload || this.isMessageUpload) {
        this.notificationService.onDelaySuccess('Report settings was saved.', undefined, 5000);
      }
    }, 1000);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  uploadFile(fileArr, fileLabel: string, fileType: string, fileSize?: number): void {
    if (fileArr.length > 0) {
      const myFile = fileArr[0];
      this.uploadFileList(myFile, fileType);
    } else {
      this.notificationService.onFail('Please upload a file');
    }
  }

  uploadFileList(file: File, fileType: string): any {
    const formData: FormData = new FormData();
    formData.append(fileType, file);

    this.dataSourceService
      .jmepUpload(formData)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          if (response.status === 'success') {
            this.isLoading = false;
            this.isUpload = true;
            this.removeLogo();
          } else {
            this.isLoading = false;
            this.isUpload = false;
            this.notificationService.onFail('File upload failed. Please try again.');
          }
        },
        error => {
          this.isLoading = false;
          this.notificationService.onFail('File upload failed. Please try again.');
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
